// Libs
import React from 'react';
// Components
import { TableVirtualized, Flag } from 'components';

const { Row, onRightClickRow, onClickRow } = TableVirtualized;

const RowRenderer = ({
	rowKey,
	columns,
	style,
	filteredDatasource,
	selected,
	setState,
	rowData,
	selectionKey = 'id',
	disableSelection = false,
	isOrdersControlRootTable = false,
	isExplicitSelectionTable = false,
}) => {
	const onFilterItems = filteredItems => {
		setState(prev => ({
			...prev,
			selected: { ...prev.selected, items: filteredItems },
		}));
	};

	const rowIdentity =
		rowData[selectionKey] ?? rowData?.wtdi_id ?? rowData?.wtdiId ?? rowData?.Id;
	const isSelected =
		selected.items.findIndex(itemId => itemId === rowIdentity) !== -1;

	const styleRow = {
		...style,
		color: isSelected && 'lightseagreen',
		backgroundColor: isSelected && 'rgba(0, 0, 0, 0.3)',
	};

	return (
		<Row
			key={rowKey}
			style={styleRow}
			$suppressHoverAffordance={
				isOrdersControlRootTable || isExplicitSelectionTable
			}
			role={
				isOrdersControlRootTable || isExplicitSelectionTable ? 'row' : undefined
			}
			aria-selected={
				isOrdersControlRootTable || isExplicitSelectionTable
					? isSelected
					: undefined
			}
			onClick={
				disableSelection
					? undefined
					: () =>
							onClickRow({
								id: rowIdentity,
								selected,
								onClickedRow: onFilterItems,
							})
			}
			onContextMenu={
				disableSelection
					? undefined
					: e =>
							onRightClickRow(
								e,
								selectionKey,
								selected.items,
								filteredDatasource,
								onFilterItems,
							)
			}
		>
			{rowData.priority && !isOrdersControlRootTable && (
				<Flag
					absolute
					height={`${style.height}px`}
					style={rowData.priority.style}
				/>
			)}
			{columns}
		</Row>
	);
};

export default RowRenderer;
